import React from 'react'
import { observer } from 'mobx-react-lite'
import { useSidebarCollapse } from '../../../../../contexts/SidebarCollapseContext'
import { ImageFill } from 'react-bootstrap-icons'


export default observer(function DraftReviewWindow() {
  const { isCollapsed } = useSidebarCollapse()

  const leftPosition = isCollapsed ? 479 : 575
  const width = isCollapsed ? 'calc(100vw - 479px)' : 'calc(100vw - 575px)'

  return (
    <div
      className='fixed top-[52px] flex flex-col justify-center items-center p-5 transition-all duration-300'
      style={{
        left: `${leftPosition}px`,
        height: 'calc(100vh - 52px)',
        width: width
      }}
    >
      <div className="flex justify-between items-center bg-white dark:bg-rb-dark-mode border-1 border-rb-widget-border dark:border-rb-dark-mode-lighter rounded-lg py-3 px-2 w-[650px] mb-4">
        <h2 className='font-bold text-lg dark:text-white'>Please select an action</h2>
        <span className='bg-gray-100 dark:bg-rb-dark-mode-lighter rounded-md w-[92px] h-[32px]'/>
      </div>

      <div className='w-[650px] h-[228px] flex justify-center items-center bg-white dark:bg-rb-dark-mode border-1 border-rb-widget-border dark:border-rb-dark-mode-lighter rounded-lg mb-4'>
        <div className="flex flex-col justify-center items-center">
          <ImageFill className='h-8 w-8 dark:text-gray-400' style={{color: "#C5CCCB"}}/>
          <p className="font-bold dark:text-white">Select your influencer and action</p>
          <p className="dark:text-gray-400">from the drafts list on the left</p>
        </div>
      </div>

      <div className="flex justify-between bg-white dark:bg-rb-dark-mode border-1 border-rb-widget-border dark:border-rb-dark-mode-lighter rounded-lg py-3 px-2 w-[650px] mb-4">
        <span className='bg-gray-100 dark:bg-rb-dark-mode-lighter rounded-md w-[32px] h-[32px]' />
        <span className='bg-gray-100 dark:bg-rb-dark-mode-lighter rounded-md w-[92px] h-[32px]' />
      </div>

      <div className="flex flex-col items-end gap-2 bg-white dark:bg-rb-dark-mode border-1 border-rb-widget-border dark:border-rb-dark-mode-lighter rounded-lg py-3 px-2 w-[650px] mb-4">
        <div className='bg-gray-100 dark:bg-rb-dark-mode-lighter rounded-md w-full h-[28px]' />
        <span className='bg-gray-100 dark:bg-rb-dark-mode-lighter rounded-md w-[62px] h-[32px]' />
      </div>
    </div>
  )
})
